import React from "react"
import moment from "moment"

const getContactRoutes = () => {
  let base = ""
  if (process.env.REACT_APP_ENV === "production") {
    base = "https://qarabao.com/contact.html"
  } else if (process.env.REACT_APP_ENV === "staging") {
    base = "https://staging.qarabao.com/contact.html"
  } else if (process.env.REACT_APP_ENV === "dev") {
    base = "https://dev.qarabao.com/contact.html"
  } else {
    base = "http://0.0.0.0:3000/contact.html"
  }
  return base
}

function CheckoutFooter({ businessName }) {
  return (
    <footer className="content-section">
      <a href={getContactRoutes()}>CONTACT US</a>
      <span>
        &copy; {businessName}, {moment().format("Y")}
      </span>
    </footer>
  )
}

export default CheckoutFooter
